<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { getRandomHexColor, hexWithOpacity } from '@/utils/helper.ts'

interface Props {
  data: any
}
const props = defineProps<Props>()


const labelSet = computed(() => {
  if(!props.data || props.data.length == 0) return []
  return props.data.map((item: any) => {
    return item.category
  })
})

const companyDataSet = computed(() => {
  if(!props.data || props.data.length == 0) return []
  return props.data.map((item: any) => {
    return item.companyCommission
  })
})

const brokerDataSet = computed(() => {
  if(!props.data || props.data.length == 0) return []
  return props.data.map((item: any) => {
    return item.brokerCommission
  })
})



const chartOptions = ref({
  chart: { stacked: true },
  stroke: { width: [0, 0, 2], curve: 'smooth' },
  plotOptions: { bar: { columnWidth: '50%' } },
  fill: { opacity: [0.8, 0.8, 1], colors: ['#007cf4', '#32a800', '#da0000'] },
  labels: Array.from({ length: 12 }, (_, i) => `Tháng ${i + 1}`),
  markers: { size: 0 },
  xaxis: {
    type: 'category',
  },
  yaxis: {
    title: { text: 'Hoa hồng' },
    min: 0,
  },
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter: (y) => (typeof y !== 'undefined' ? `${y.toFixed(0)} vnđ` : y),
    },
  },
})

const series = ref([
  {
    name: "Hoa hồng công ty",
    type: "column",
    data: companyDataSet.value
  },
  {
    name: "Hoa hồng cho môi giới",
    type: "column",
    data: brokerDataSet.value
  },
  {
    name: "Tổng hoa hồng",
    type: "line",
    data: brokerDataSet.value
  },
])
</script>

<template>
  <apexchart width="100%" height="350px" type="line" :options="chartOptions" :series="series"></apexchart>
</template>

<style scoped>

</style>
